import React from "react";
import s from "./style.module.scss";
import InfoIcon from "@/assets/info-outline.svg?react";
import clsx from "clsx";

interface InfoTipProps {
  children?: React.ReactNode;
  classname?: string
}

export const InfoTip = ({ children, classname }: InfoTipProps) => {
  return (
    <div className={clsx(s.infotip, classname)}>
      <div>
        <InfoIcon />
      </div>
      <p>{children}</p>
    </div>
  );
};
